import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { chooseAssessmentConfig } from '../../config/ChooseAssessmentConfig';
import { AppSelector, useAppStore } from '../../store/Store';

export const ConfigToolbox: FunctionComponent = () => {
  const currentPage = useAppStore(AppSelector.currentPage);
  const config = useAppStore(chooseAssessmentConfig);
  return (
    <ConfigLabel>
      <p>
        <strong>Page:</strong> {currentPage}
      </p>
      <p>
        <strong>Current Config:</strong> {config.name}
      </p>
    </ConfigLabel>
  );
};

const ConfigLabel = styled.div`
  word-break: break-all;
`;
